import ExpireLinkPage from '@/views/ExpireLink/index.vue'

const ExpireLinkPageRouter = {
  path: '/expire-link',
  name: 'ExpireLink',
  component: ExpireLinkPage,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default ExpireLinkPageRouter
